import type {CheckoutBillingAddress} from '@Components/checkout-flow/checkout-flow.types';

export const getBillingAddressSubText = (address: CheckoutBillingAddress): string => {
  const parts = [address.city, address.region, address.countryCode, address.postalCode].filter((part) => part !== '');
  const location = parts.join(', ');
  return address.phone !== '' ? `${location} - ${address.phone}` : location;
};
